export const NUMBERS_ERROR = '半角数字のみ入力できます'

export const GET_BOOK_NAME_ERROR = (
  maxLength: number,
) => `ひらがな${maxLength}文字以内で入力してください`;

export const GET_BOOK_NAME_ERROR_EN = (
  maxLength: number,
) => `英語${maxLength}文字以内で入力してください`;

export const BOOK_MESSAGE_MAX_ROW_LENGTH = 32;
export const BOOK_MESSAGE_MAX_ROW_LENGTH_WBT = 24;
export const BOOK_MESSAGE_MAX_ROW_LENGTH_WIBC = 23;
export const BOOK_MESSAGE_MAX_ROW_LENGTH_SOGG = 25;

export const BOOK_MESSAGE_MAX_ROWS = 10;
export const BOOK_MESSAGE_MAX_ROWS_WBT = 7;
export const BOOK_MESSAGE_MAX_ROWS_WIBC = 9;
export const BOOK_MESSAGE_MAX_ROWS_SOGG = 11;

export const EMAIL_ERROR = '＠を含む有効なメールアドレスを半角英数字で入力してください'

export const EMAIL_MATCH_ERROR = 'メールアドレスが一致しません'

export const PASSWORD_MATCH_ERROR = 'パスワードが一致しません'

export const REQUIRED_ERROR = '入力してください'

export const NAME_MAX_LENGTH = 7
export const NAME_ERROR = '日本語かアルファベットのみ入力できます'

export const POSTAL_CODE_1_MAX_LENGTH = 3
export const POSTAL_CODE_2_MAX_LENGTH = 4
export const POSTAL_CODE_ERROR = '半角英数字で入力してください'

export const ADDRESS_1_ERROR = '選択してください'

export const ADDRESS_2_MAX_LENGTH = 22
export const ADDRESS_2_ERROR = '半角カナや特殊文字は入力できません'

export const ADDRESS_3_MAX_LENGTH = 22
export const ADDRESS_3_ERROR = ADDRESS_2_ERROR

export const PHONE_1_MAX_LENGTH = 5
export const PHONE_2_MAX_LENGTH = 4
export const PHONE_3_MAX_LENGTH = 4
export const PHONE_ERROR = '半角英数字で入力してください'
